/**
 * Element Viewed event - tracks when users view a specific element on the page
 * Limit 1 view event per element per page view
 */

import { z } from 'zod';

import { defineEvent } from '../event-factory';
import { buildTrackingKey, flattenForTrackingKey } from '../utils';

export default defineEvent({
  eventName: 'redventures.usertracking.v3.ElementViewed',

  // What data this event needs (see schema link for full details)
  // https://app.make.rvohealth.com/schemas/sch_1KdMzy1S6c7Aqjibny2JP9HC1Fb
  cohesionSchema: {
    correlationId: z.uuid().optional(),
    webElement: z.object({
      elementType: z.string().optional(),
      htmlId: z.string().optional(),
      location: z.string().optional(),
      name: z.string().optional(),
      position: z.string().optional(),
      text: z.string().optional(),
    }),
    viewCorrelationId: z.uuid().optional(), // id that ties the "element viewed" event back to the "element loaded" event and forward to the "element clicked" event

    customDimensions: z
      .array(
        z.object({
          key: z.string(),
          value: z.string(),
        }),
      )
      .optional(), // additional information about the event
    listId: z.string().optional(), // Since Products will be viewed & clicked from a list or product grid, we need a UUID for that product grid instance
  },

  tealiumMethodType: 'view',

  // Deduplication: One event per unique webElement+viewCorrelationId combo per page view
  deduplication: {
    scope: 'page',
    keyBuilder: (params) =>
      buildTrackingKey(
        flattenForTrackingKey({
          ...params.webElement,
          ...(params.viewCorrelationId && {
            viewCorrelationId: params.viewCorrelationId,
          }),
        }),
      ),
  },
});
